import { DependencyInjectionContainer } from "./dependency-injection-container";
import { PermissionsSetService } from "../roles-permissions/services/permissions-set-service";

const key = "permissionSetService";

export const getPermissionsSetService = () => {
  return DependencyInjectionContainer.getInstance().resolve<PermissionsSetService>(
    key,
  );
};

export const registerPermissionsSetService = () => {
  DependencyInjectionContainer.getInstance().register(
    key,
    PermissionsSetService,
  );
};
